import { Dispatch, createContext, useContext, useEffect } from "react";
import {
  PersonalInfoFormAction,
  PersonalInfoFormFields,
  usePersonalInformationReducer,
} from "app/hooks/";

interface CheckoutInfoProviderProps {
  state: PersonalInfoFormFields;
  dispatch: Dispatch<PersonalInfoFormAction>;
}

const CheckoutInfoContext = createContext({} as CheckoutInfoProviderProps);
export const useCheckoutInfoContext = () => useContext(CheckoutInfoContext);
const CheckoutInfoProvider = ({ children }: any) => {
  const { state, dispatch } = usePersonalInformationReducer();

  return (
    <CheckoutInfoContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </CheckoutInfoContext.Provider>
  );
};
export default CheckoutInfoProvider;
